import type { Review, ReviewJsonItem } from '~/services/BasicServer/types'
// 将评分字符串转换为数字
const parseRating = (ratingStr: string | undefined): number => {
    if (!ratingStr) return 5
    const match = ratingStr.match(/(\d+)/)
    return match ? parseInt(match[1]) : 5
}

// 格式化日期
const formatDate = (date: string | number | undefined): string => {
    if (!date) return new Date().toISOString().split('T')[0]

    // 如果是数字（时间戳），转换为日期字符串
    if (typeof date === 'number') {
        return new Date(date).toISOString().split('T')[0]
    }

    // 如果是日期字符串，尝试格式化
    const dateStr = date.toString()
    // 处理 "11/18/2025" 格式
    if (dateStr.includes('/')) {
        const parts = dateStr.split('/')
        if (parts.length === 3) {
            return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`
        }
    }

    return dateStr
}

// 判断用户类型和功能类型
const detectUserTypeAndFeature = (text: string, profession: string): { userType?: 'enterprise' | 'individual', feature?: 'ocr' | 'contract' } => {
    const result: { userType?: 'enterprise' | 'individual', feature?: 'ocr' | 'contract' } = {}

    // 判断用户类型
    const enterpriseKeywords = ['公司', '企业', '团队', '经理', '主管', '总监', '财务', '会计', 'HR', '律师', '法务', '医生', '医院', '银行', '招聘']
    const individualKeywords = ['学生', '同学', '老师', '教师', '研究生', '博士生', '个人', '家长', '宝妈', '租客', '求职者', '自由职业']

    const lowerText = text.toLowerCase()
    const lowerProfession = profession.toLowerCase()

    if (enterpriseKeywords.some(keyword => lowerText.includes(keyword) || lowerProfession.includes(keyword))) {
        result.userType = 'enterprise'
    } else if (individualKeywords.some(keyword => lowerText.includes(keyword) || lowerProfession.includes(keyword))) {
        result.userType = 'individual'
    }

    // 判断功能类型
    const ocrKeywords = ['OCR', 'ocr', '识别', '扫描', '发票', '扫描件']
    const contractKeywords = ['合同', '契约', '签名', '签署', 'PDF改字', 'PDF编辑', '文字修正', '编辑']

    if (ocrKeywords.some(keyword => lowerText.includes(keyword))) {
        result.feature = 'ocr'
    } else if (contractKeywords.some(keyword => lowerText.includes(keyword))) {
        result.feature = 'contract'
    }

    return result
}

// 转换 JSON 数据为 Review 格式
const convertJsonToReview = (item: ReviewJsonItem, index: number, lang: string): Review => {
    let name = ''
    let text = ''
    let profession = ''
    let date = ''
    let rating = 5

    if (lang === '中文') {
        name = item.姓名 || item.用户姓名 || ''
        text = item['文案 (结合特色与SEO关键词)'] || ''
        profession = item.职业 || ''
        date = formatDate(item.时间)
        rating = parseRating(item.评分)
    } else if (lang === '英文') {
        name = item.Name || ''
        text = item['Review Text'] || ''
        profession = item.Profession || ''
        date = formatDate(item.Date)
        rating = parseRating(item.Rating)
    } else if (lang === '日语') {
        name = item.名前 || ''
        text = item.レビュー内容 || ''
        profession = item.職業 || ''
        date = formatDate(item.日付)
        rating = parseRating(item.評価)
    } else if (lang === '德语') {
        name = item.Name || ''
        text = item['Review Text'] || ''
        profession = item.Profession || ''
        date = formatDate(item.Date)
        rating = parseRating(item.Rating)
    }

    const { userType, feature } = detectUserTypeAndFeature(text, profession)

    return {
        id: index + 1,
        rating,
        text,
        name,
        title: profession,
        date,
        verified: true,
        userType,
        feature
    }
}

export { convertJsonToReview }
